module.exports = __webpack_public_path__ + "static/media/thermopi.d638cb7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/entries/thermopi.jpg
// module id = 1083
// module chunks = 0